import { apiRequest } from './client'
import type { SilkDashboard, SilkRealname, SilkUser } from './types'

export const accountApi = {
  dashboard: (days = 30) =>
    apiRequest<SilkDashboard>('/api/v1/account/dashboard', { query: { days } }),

  updateProfile: (body: {
    nickname?: string
    avatar_url?: string
    cover_photo_url?: string
    bio?: string
    social_links?: import('./types').SilkSocialLink[]
    featured_work_ids?: number[]
  }) =>
    apiRequest<SilkUser>('/api/v1/account/profile', {
      method: 'PATCH',
      body,
    }),

  bindPhone: (body: { phone: string; sms_code?: string }) =>
    apiRequest<SilkUser>('/api/v1/account/phone', {
      method: 'PATCH',
      body,
    }),

  bindEmail: (body: { email: string }) =>
    apiRequest<SilkUser>('/api/v1/account/email', {
      method: 'PATCH',
      body,
    }),

  realname: () => apiRequest<SilkRealname>('/api/v1/account/realname'),

  submitRealname: (body: { legal_name: string; id_number_last4: string; provider?: string }) =>
    apiRequest<SilkRealname>('/api/v1/account/realname', {
      method: 'POST',
      body,
    }),
}
